import styled from 'styled-components';

import { SearchInput, Typography } from '@libs/components';

export const CryptoNetworksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 2rem;
  ${({ theme }) => theme.media.tablet`
  padding: 1.6rem 3.6rem 3.6rem 3.6rem;

  `};

  gap: 1.6rem;
`;

export const CustomSearchInput = styled(SearchInput)`
  border-radius: ${({ theme }) => theme.borderRadius.x8};
  width: 100%;
`;

export const TitleTypography = styled(Typography)`
  text-align: left;
  width: 100%;
`;
